import { HYDRATE } from 'next-redux-wrapper';

import {
    ERROR_CLIENT_EQUIPMENT_INFO,
    GET_CLIENT_EQUIPMENT_INFO,
    SET_CLIENT_EQUIPMENT_INFO,
} from '~/src/store/actionTypes/clientEquipmentInfo';

const initialState = {
    isFetching: false,
    equipment: [],
    error: null,
};

function deserializeEquipmentInfoItem(item) {
    return {
        ...item,
        activeTo: item.activeTo ? new Date(item.activeTo) : null,
        activeFrom: item.activeFrom ? new Date(item.activeFrom) : null,
        warranty: item.warranty ? new Date(item.warranty) : null,
    };
}


/**
 * @param state
 * @param action
 * @return {{isFetching: boolean, equipment: [], error: string|null}}
 */
export default (state = initialState, action) => {
    switch (action.type) {
        case HYDRATE:
            return {
                isFetching: action.payload.clientEquipmentInfo.isFetching,
                equipment: action.payload.clientEquipmentInfo.equipment.map(deserializeEquipmentInfoItem),
                error: action.payload.clientEquipmentInfo.error,
            };
        case GET_CLIENT_EQUIPMENT_INFO:
            return {
                ...state,
                isFetching: true,
            };
        case SET_CLIENT_EQUIPMENT_INFO: {
            return {
                ...state,
                isFetching: false,
                equipment: action.payload.map(deserializeEquipmentInfoItem),
            };
        }
        case ERROR_CLIENT_EQUIPMENT_INFO: {
            return {
                ...state,
                isFetching: false,
                error: action.payload,
            };
        }
        default: {
            return state;
        }
    }
};
